<script setup lang="ts">
const route = useRoute();
const config = useRuntimeConfig();

const { data: artworks } = await useFetch<Artwork[]>(`/api/artworks?category-slug=${route.params.artwork}`);

useHead({
  title: `${artworks.value?.[0]?.categoria.title || "Artworks"}`,
});
</script>
<template>
  <div class="content">
    <Breadcumb
      :title="artworks![0]?.categoria.title || 'Artworks'"
      :subtitle="'A collection of my artworks.'"
      :items="[{ text: 'Artworks', href: '/artworks' }]"
      :to="{ text: artworks![0]?.categoria.title || 'Artworks', href: `/artworks/${artworks![0]?.categoria.slug}` }"
    />

    <IndexArtworksGrid :artworks="artworks!" :categories="[]" />
  </div>
</template>
